import QrScanner from "qr-scanner";
import { Howl, Howler } from "howler";

const synth = window.speechSynthesis;
let speech: null | SpeechSynthesisUtterance = null;
const voice =
  synth.getVoices().find((voice) => voice.lang === "de-DE") ||
  synth.getVoices()[0];
console.log(voice);

let currentQrCode = "";
let sound: null | Howl = null;

// To enforce the use of the new api with detailed scan results, call the constructor with an options object, see below.
const qrScanner = new QrScanner(
  assertNotNull(document.querySelector("video")),
  onDecode,
  {
    /* your options or returnDetailedScanResult: true if you're not specifying any other options */
  },
);

qrScanner.start();

function onDecode(result: QrScanner.ScanResult) {
  if (currentQrCode === result.data) {
    return;
  }

  currentQrCode = result.data;
  console.log("decoded qr code:", result);

  const qrCodeContent = document.querySelector("#qr-code-content");
  if (qrCodeContent) {
    qrCodeContent.textContent = result.data;
  }

  // sound = new Howl({
  //   src: ["public/ode-to-joy-piano-68697.mp3"],
  //   html5: true,
  // });
  speech = new SpeechSynthesisUtterance(result.data);
  speech.voice = voice;
  synth.speak(speech);
}

function assertNotNull(e: any) {
  if (e === null) {
    throw new Error(`${e} is null, expected otherwise.`);
  }

  return e;
}

document.querySelector("#stop-button")?.addEventListener("click", () => {
  //sound?.stop();
  if (!speech) {
    return;
  }
  synth.pause();
});

document.querySelector("#repeat-button")?.addEventListener("click", () => {
  if (!speech) {
    return;
  }
  synth.speak(speech);
});
